import React, { useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import HomeLayout from "../HomeLayout/HomeLayout"
import CoolLightbox from "../LightBox/CoolLightBox"
const Page4 = ({onChange}) => {
  const [isOpen, setOpen] = useState(false)
  const [currentImageIndex, setCurrentIndex] = useState(0)

  const data = useStaticQuery(graphql`
    query {
      Page4: allFile(
        sort: { order: ASC, fields: name }
        filter: { sourceInstanceName: { eq: "EventManagementPage4" } }
      ) {
        nodes {
          id
          name
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      EventManagementInfoPage4: allFile(
        sort: { order: ASC, fields: name }
        filter: { sourceInstanceName: { eq: "EventManagementInfoPage4" } }
      ) {
        nodes {
          id
          name
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  `)

  var images = []
  data.EventManagementInfoPage4.nodes.map(img => {
    var src = img.childImageSharp.fluid.src
    images.push({
      src,
    })
  })


  return (
    <HomeLayout>
        <>
          {data.Page4.nodes.map((img, index) => {
            if(index>3) return <Img fluid={img.childImageSharp.fluid} />
            return (
              <div
                onClick={() => {
                  setCurrentIndex(index)
                  setOpen(true)
                  onChange(false)
                }}
              >
                <Img fluid={img.childImageSharp.fluid} />
              </div>
            )
          })}
          <CoolLightbox
           images={images}
           setCurrentIndex={setCurrentIndex}
           currentImageIndex={currentImageIndex}
           isOpen={isOpen}
           onClose={() => {setOpen(false)
            onChange(true)}}
          />
          
        </>
        </HomeLayout>
  )
}
export default Page4
